import { Container as MUIContainer, type ContainerProps } from '@mui/material';

interface Props extends Omit<ContainerProps, 'maxWidth'> {
  children: React.ReactNode;
}

export function Container({ children, sx, ...props }: Props) {
  return (
    <MUIContainer
      maxWidth="lg"
      sx={{
        px: 3,
        ...sx,
      }}
      {...props}
    >
      {children}
    </MUIContainer>
  );
}
